module.exports = __webpack_public_path__ + "static/CocoaMass-69cfe85ee8d7fbf1b2b7b124c2173874.webp";